<template>
    <div></div>
</template>

<script>
import { LudumEventBus, REFRESH_SQUADS, CLUB_MEMBERS_LOAD } from '@/event-bus';
import { isMultisportSession } from '@/helpers/sessionHelper';

export default {
    watch: {
        'selectedClub.club_id': {
            immediate: true,
            handler(value) {
                if (value) {
                    this.loadUsers();
                    this.loadSquads();
                    this.loadEventTags();
                }
            }
        }
    },

    created() {
        this.getSessionTypes();
        this.getFocuses();
        this.getIntensities();
        this.getUnitsOfMeasurement();
    },

    mounted() {
        LudumEventBus.$on(REFRESH_SQUADS, this.loadSquads);
        LudumEventBus.$on(CLUB_MEMBERS_LOAD, this.loadUsers);
    },

    methods: {
        getSessionTypes() {
            this.$store.dispatch('get', {
                url: api + 'session-types'
            }).then(response => {
                const sessionTypes = _.filter(
                    response.data,
                    sessionType => !isMultisportSession(sessionType.id)
                );
                this.$store.commit('clubHelper/fillSessionTypes', sessionTypes);
                this.$store.commit('sessionTypes', sessionTypes);
            }).catch(error => {
                this.error = error;
            });
        },

        loadUsers() {
            const that = this;
            that.$store.commit('clubHelper/fillUsers', []);
            this.getClubUsers().then(function collect({ data: { data, meta } }) {
                that.$store.commit('clubHelper/fillUsers', data);
                if (meta.pagination.current_page < meta.pagination.total_pages) {
                    return that.getClubUsers(meta.pagination.current_page + 1).then(collect);
                }
            }).catch(() => {
                // swallow error
            });
        },

        getClubUsers(page = 1, status = [0, 1, 3, 4, 6]) {
            return this.$store.dispatch('clubHelper/getClubUsers', {
                clubId: this.selectedClub.club_id,
                status,
                page
            });
        },

        loadSquads() {
            return this.$store.dispatch('clubHelper/getClubSquads', {
                club_id: this.selectedClub.club_id
            }).catch(() => {
                // swallow error
            });
        },

        loadEventTags() {
            const that = this;
            that.$store.commit('clubHelper/fillEventTags', []);
            this.getEventTags().then(function collect({ data: { data, meta } }) {
                that.$store.commit('clubHelper/fillEventTags', data);
                if (meta.pagination.current_page < meta.pagination.total_pages) {
                    return that.getEventTags(meta.pagination.current_page + 1).then(collect);
                }
            }).catch(() => {
                // swallow error
            });
        },

        /**
         * Get club tags
         */
        getEventTags(page = 1) {
            return this.$store.dispatch('get', {
                url: api + 'event-tags',
                params: {
                    club_id: this.selectedClub.club_id,
                    limit: 500,
                    page: page
                }
            });
        },

        /**
         * Get sport focuses
         */
        getFocuses(sportId = null) {
            this.$store.dispatch('get', {
                url: api + 'focuses',
                params: {
                    sport: sportId
                }
            }).then(response => {
                this.$store.commit('clubHelper/fillFocuses', response.data);
                this.$store.commit('calendarFocuses', response.data);
            }).catch(error => {
                this.error = error;
            });
        },

        getIntensities() {
            this.$store.dispatch('clubHelper/getIntensities');
        },

        getUnitsOfMeasurement() {
            this.$store.dispatch('get', {
                url: api + 'units-of-measurement'
            }).then(response => {
                this.$store.commit('clubHelper/fillUnitsOfMeasurement', response.data);
            }).catch(error => {
                this.error = error;
            });
        }
    },

    computed: {
        selectedClub() {
            return this.$store.getters.selectedClub;
        }
    }
};
</script>
